export { default as FolderCubeSolidIcon } from './FolderCubeSolidIcon';
